var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_2997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8125 5.625H6.1875C5.25552 5.625 4.5 6.38052 4.5 7.3125C4.5 8.24448 5.25552 9 6.1875 9H20.8125C21.7445 9 22.5 8.24448 22.5 7.3125C22.5 6.38052 21.7445 5.625 20.8125 5.625Z",
    fill: "#B0B7C3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4375 12.375H18.5625C19.4945 12.375 20.25 13.1305 20.25 14.0625C20.25 14.9945 19.4945 15.75 18.5625 15.75H8.4375C7.50552 15.75 6.75 14.9945 6.75 14.0625C6.75 13.1305 7.50552 12.375 8.4375 12.375ZM11.8125 19.125H15.1875C16.1195 19.125 16.875 19.8805 16.875 20.8125C16.875 21.7445 16.1195 22.5 15.1875 22.5H11.8125C10.8805 22.5 10.125 21.7445 10.125 20.8125C10.125 19.8805 10.8805 19.125 11.8125 19.125Z",
    fill: "#B0B7C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_2997"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSign);
export default __webpack_public_path__ + "static/media/filterSign.36b7f54fbb4a30f8595013df05a0f134.svg";
export { ForwardRef as ReactComponent };